import { Typography } from "@atoms/typography";
import { routes } from "@fhlib/routes";
import { useFHConfig } from "@templates/config";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import { useRouter } from "next/router";
import { FC, useMemo } from "react";
import styled from "styled-components";

export type BlogListArticleProps = {
  title: string;
  cover: string;
  slug: string;
};

export const BlogListArticle: FC<BlogListArticleProps> = ({
  title,
  cover,
  slug,
}) => {
  const config = useFHConfig();
  const router = useRouter();

  const articleEndpoint = useMemo(
    () => `${routes["blog"][router?.locale ?? "en"]}/${slug}`,
    [router, slug]
  );

  return (
    <Link href={articleEndpoint} passHref legacyBehavior>
      <Container>
        <div className="article-header">
          <picture>
            <source
              srcSet={`${config.backUrl}/assets/${cover}?fit=cover&width=333&height=222&format=webp`}
              type="image/webp"
            />
            <img
              className="article-image"
              alt={`Cover ${title}`}
              src={`${config.backUrl}/assets/${cover}?fit=cover&width=333&height=222`}
              width="333"
              height="222"
              loading="lazy"
            />
          </picture>
        </div>
        <div className="article-content">
          <Typography variant="title2">{title}</Typography>
        </div>
      </Container>
    </Link>
  );
};

const Container = styled.a`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: 23rem;
  width: 100%;
  transition: transform 0.3s;
  background-color: #fff;
  text-decoration: none;
  border: 1px solid #ebebeb;
  border-top: 4px solid #eabc09;

  .article-header {
    position: relative;
    overflow: hidden;

    .article-image {
      width: 100%;
      height: auto;
      display: block;
      transition: transform 0.3s;
    }
  }

  .article-content {
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 0.5em 1em;

    h2 {
      margin: 0.5em 0;
      font-size: 1.2em;
      flex: 1;
    }
  }

  &:hover {
    transform: Scale(1.03);
    .article-image {
      transform: Scale(1.05);
    }
  }
`;
